import { handleFormSubmit, useAuth, useRequest } from '@polvo-labs/react-auth'
import React from 'react'
import { toast } from 'react-toastify'
import Form from '../../components/Form'
import fields, { ChangePasswordFormData } from './fields'

interface Props {
  onSubmit: () => void
}

const ChangePasswordForm: React.FC<Props> = ({ onSubmit }) => {
  const { request } = useRequest()
  const { token } = useAuth()

  return (
    <Form<ChangePasswordFormData>
      buttonLabel="ENVIAR"
      fields={fields}
      onSubmit={data => handleFormSubmit({
        request: request({
          method: 'PUT',
          url: `${process.env.REACT_APP_API_URL}/user/change-password`,
          data,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
        onValidationErrors: () => toast.error('Erros de validacao.'),
        onSuccess: () => {
          toast.success('Seus dados foram atualizados com sucesso.')
          onSubmit()
        },
        onFailure: () => toast.error('Erro ao alterar informações.'),
      })}
    />
  )
}

export default ChangePasswordForm
